import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import cn from 'classnames'
import InstagramEmbed from 'react-instagram-embed'
//import {canUseDom} from '../../utils/dom'
import CircleSpinner from '../Widgets/CircleSpinner'
import CentredContentContainer from "../Widgets/CentredContentContainer";
import query from 'dom-helpers/query'
import style from 'dom-helpers/style'
import first from 'lodash/first'

class InstagramSlice extends PureComponent {

    state = {
        loaded: false,
    }

    setIFrameStyles = () => {
        if(!this._ref) return;
        const iframe = first(query.querySelectorAll(this._ref, 'iframe'));
        if(!iframe) return;
        style(iframe, 'max-width', '860px');
        style(iframe, 'width', '98%');
    }

    onLoaded = () => {
        this.setState({loaded: true})
    }

    setRef = (ref) => {this._ref = ref;}

    render() {
        const {classes, item} = this.props;
        const {loaded} = this.state;

        return <section ref={this.setRef}>
            <CentredContentContainer className={cn(classes.container, {loaded})}>
                    <InstagramEmbed
                        url={item.instagram_link.embed_url}
                        className={classes.instagramEmbed}
                        hideCaption={false}
                        containerTagName='div'
                        injectScript
                        onSuccess={this.onLoaded}
                        onAfterRender={this.setIFrameStyles}
                    />
                    {!loaded &&
                        <div className={classes.placeholder}>
                            <div className={classes.spinner}>
                                <CircleSpinner show={true}/>
                            </div>
                        </div>
                    }
            </CentredContentContainer>
        </section>
    }
}

export default injectSheet(theme => ({
    placeholder: {
        backgroundColor: theme.colors.info,
        position: 'relative',
        minHeight: 300,
        '&.loaded': {
            backgroundColor: 'transparent'
        }
    },
    spinner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    instagramEmbed: {
        margin: '-1%',
        '& iframe': {
            margin: '0 auto !important',
            maxWidth: '658px !important'
        }
    }
}))(InstagramSlice)





// WEBPACK FOOTER //
// ./src/components/Article/InstagramSlice.js